module.exports = __webpack_public_path__ + "static/media/CreateQuote.997a7482.svg";